import { render, staticRenderFns } from "./userRoleSelect.vue?vue&type=template&id=394ff48c&scoped=true&"
import script from "./userRoleSelect.vue?vue&type=script&lang=js&"
export * from "./userRoleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394ff48c",
  null
  
)

export default component.exports